import { render, staticRenderFns } from "./tabs-swift.vue?vue&type=template&id=6d5a7824&"
import script from "./tabs-swift.vue?vue&type=script&lang=js&"
export * from "./tabs-swift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports